import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular

export const getAllPendingProposalAction = (body) => ({
  type: actions.GET_PENDING_SUPPLIER_PUBLIC_PROPOSALS,
  payload: body
})

export const getAllPendingProposalSucessAction = (proposals) => ({
  type: actions.GET_PENDING_SUPPLIER_PUBLIC_PROPOSALS_SUCCESS,
  payload: proposals
})

export const getSinglePendingProposalAction = (id) => ({
  type: actions.GET_SINGLE_PENDING_SUPPLIER_PUBLIC_PROPOSAL,
  payload: id
})

export const getSinglePendingProposalSuccessAction = (proposal) => ({
  type: actions.GET_SINGLE_PENDING_SUPPLIER_PUBLIC_PROPOSAL_SUCCESS,
  payload: proposal
})

export const moderatePendingProposalAction = (body) => ({
  type: actions.MODERATE_PENDING_SUPPLIER_PUBLIC_PROPOSAL,
  payload: body
})

export const moderatePendingProposalSuccessAction = (proposal) => ({
  type: actions.MODERATE_PENDING_SUPPLIER_PUBLIC_PROPOSAL_SUCCESS,
  payload: proposal
})


export const rejectPendingProposalAction = (id) => ({
  type: actions.REJECT_PENDING_SUPPLIER_PUBLIC_PROPOSAL,
  payload: id
})

export const rejectPendingProposalSuccessAction = (proposal) => ({
  type: actions.REJECT_PENDING_SUPPLIER_PUBLIC_PROPOSAL_SUCCESS,
  payload: proposal
})

/**
 * Misc
 */

export const setPendingPrivateInquiryIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_SUPPLIERS_PUBLIC_PROPOSALS_IS_LOADING,
  payload: isLoading,
});

export const setPendingPrivateInquiryCountAction = (count) => ({
  type: actions.SET_PENDING_SUPPLIERS_PUBLIC_PROPOSALS_COUNT,
  payload: count,
});
